/** @type {import('next-i18next').UserConfig} */
module.exports = {
  i18n: {
    defaultLocale: 'pt',
    locales: ['en', 'pt'],
  },
  defaultNS: 'translation',
  localePath: './public/locales',
  // pages without i18n props (the "/" language redirect, /vN) create the
  // client instance with no resources, and i18next then defers init to a
  // setTimeout. next-i18next only merges the next page's translations into an
  // already initialized instance, so if the redirect to /pt lands before that
  // timer fires (background or occluded tab, where timers are throttled) the
  // whole site stays on raw keys. Sync init closes that window
  initImmediate: false,
}
